import {Doughnut} from 'vue-chartjs'
import { mapState } from "vuex";

export default Doughnut.extend({
  props: ['workers'],
  mounted () {
    let data = [];
    let labels = [];
    let banks = [];
    let backgroundColors = [];
    if (this.workers.workers){
      Object.keys(this.workers.workers).forEach(item => {
        backgroundColors.push(getNicknameColor(this.workers.workers[item].nick_name));
        data.push(this.workers.workers[item].count);
        labels.push(this.workers.workers[item].nick_name);
      });
      this.renderChart({
        labels: labels,
        datasets: [
          {
            backgroundColor: backgroundColors,
            data: data
          }
        ]
      }, {responsive: true, maintainAspectRatio: false})
    }
  }
})

function getNicknameColor(str) {
  var color = '#';
    for (var i = 0; i < 6; i++) {
      color += str.charCodeAt(i + 1).toString(16).substring(1, 2);
    }
  console.log(color)
  return color;
}



// WEBPACK FOOTER //
// ./src/components/chart/DoughnutWorkers.js